
import React from 'react'
import produce from 'immer'
import { useRecoilState } from 'recoil'

import { bookmarksAtom } from '../components/atoms'
import Symbol from '../helpers/Symbol'


export default function BookmarkButton(slug) { 

	const [bookmarks, setBookmarks] = useRecoilState(bookmarksAtom)
	const isBookmarked = bookmarks.findIndex(s => s === slug) !== -1

	const handleBookmark = event => {
		event.preventDefault()
		setBookmarks(prev => produce(prev, draft => {
			if (isBookmarked) {
				const idx = draft.findIndex(p => p === slug)
				if (idx !== -1) 
					draft.splice(idx, 1)
			} else {
				draft.push(slug)
			}
		}))
	}	

	const BookmarkButton = <button
		onClick={handleBookmark}
		className={`pinBtn ${isBookmarked ? 'pinned' : ''}`}
		// title="Save"
	>
		<Symbol id='star' />
	</button>

	return {
		isBookmarked,
		BookmarkButton,
	}
}